if (!customElements.get('ps-purchase-dock')) {
  customElements.define('ps-purchase-dock', class extends HTMLElement {
    connectedCallback() {
      const section = document.getElementById(this.dataset.sectionId);
      this.purchaseButton = section?.querySelector('product-form button[name="add"]');
      if (!this.purchaseButton) return;

      this.goToPurchase = () => {
        this.purchaseButton.scrollIntoView({ block: 'center', behavior: 'auto' });
        this.purchaseButton.focus({ preventScroll: true });
      };
      this.querySelector('button').addEventListener('click', this.goToPurchase);
      this.visibilityObserver = new IntersectionObserver(([entry]) => {
        this.hidden = entry.isIntersecting;
      }, { threshold: 0.25 });
      this.visibilityObserver.observe(this.purchaseButton);

      const priceContainer = section.querySelector('[id^="price-"]');
      const updatePrice = () => {
        const price = priceContainer?.querySelector('.price');
        const amount = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price-item--regular');
        if (!amount) return;
        const cleanAmount = amount.cloneNode(true);
        cleanAmount.querySelectorAll('.one, .visually-hidden').forEach((label) => label.remove());
        const text = cleanAmount.textContent.trim();
        this.querySelector('[data-dock-price]').textContent = text.includes(this.dataset.currency) ? text : `${text} ${this.dataset.currency}`;
      };
      if (priceContainer) {
        this.priceObserver = new MutationObserver(updatePrice);
        this.priceObserver.observe(priceContainer, { childList: true, subtree: true, characterData: true });
        updatePrice();
      }
    }

    disconnectedCallback() {
      this.visibilityObserver?.disconnect();
      this.priceObserver?.disconnect();
      this.querySelector('button')?.removeEventListener('click', this.goToPurchase);
    }
  });
}
